import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

const baseText = 'How to apply for a'

const applyTitles: Record<CreditCardProductCategory, string> = {
    ['BalanceTransfer']: `${baseText} balance transfer credit card`,
    ['BestCards']: `${baseText} credit card`,
    ['Cashback']: `${baseText} cashback credit card`,
    ['Combined']: `${baseText} balance transfer and purchase credit card`,
    ['PoorCredit']: `${baseText} credit card for bad credit`,
    ['Purchase']: `${baseText} 0% purchase credit card`,
    ['Rewards']: `${baseText} rewards credit card`,
    ['Travel']: `${baseText} travel credit card`,
}

export default applyTitles
